import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { OrderProvider } from "./context/OrderContext";
import { AuthProvider } from "./context/AuthContext";
import { DeliveryProvider } from "./context/DeliveryContext";
import { SocketProvider } from "./context/SocketContext";
import { TempUserProvider } from "./context/TempuserContext";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <AuthProvider>
    <TempUserProvider>
    <OrderProvider>
      <DeliveryProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
      </DeliveryProvider>
    </OrderProvider>
    </TempUserProvider>
  </AuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
